export default __webpack_public_path__ + "static/approach-4-65827f16c01587f1d7461c2fa851e0b6.svg";